var every = require('../array/virtual/every');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.every;
  return it === ArrayPrototype || it instanceof Array && own === ArrayPrototype.every ? every : own;
};